<template>
    <div class="modal hide fade in" id="modalTomos" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Agregar tomos adicionales al Documento</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                         <div class="form-group col-12">
                            <p class="text-warning">Los tomos que se definiran como adicionales son aquellos que resultan del expediente principal despues de 500 fojas, cuadernillos como tercerias, incidentes, etc, no se consideran como tomos.</p>
                        </div>
                     </div>
                    <div class="row">
                         <div class="form-group col-12">
                            <label>Tomos actuales :&nbsp; &nbsp; {{this.tomosActuales}}</label>
                        </div>
                     </div>
                     <div class="row">
                         <div class="form-group col-12">
                            <label>Cantidad para agregar:</label>
                            <input type="number" id="nombreSede_div" class="form-control" v-model="tomosAdicionales" />
                        </div>
                     </div>
                     <div class="row">
                         <div class="form-group col-12">
                            <h5><p class="text-success">Cantidad de Tomos a declarar: &nbsp; {{total}}</p></h5>
                        </div>
                     </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" id="botonCancelar" >&nbsp; &nbsp; &nbsp; &nbsp;&nbsp;Cancelar &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;</button>
                    <button type="button" class="btn btn-success" id="botonAceptar" >Agregar Adicionales</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'


export default {
    props: {
        tomosActuales : {
            type: Number,
            default: 0
        },
        areaTomos : Object,
        inventarioDocumento: Object
    },
    data(){
        return{
            tomosAdicionales: 0,
            Creados : false
        }
    },
    methods:{
        Mostrar: function () {
            $('#modalTomos').modal('show');
            $('#botonCancelar').unbind('click').click(this.ModalClose);
            $('#closeModal').unbind('click').click(this.ModalClose);
            $('#botonAceptar').unbind('click').click(this.Agregar);
            },
        ModalClose: function(){
            $('#modalTomos').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('dialogo', {'Estatus': false, 'Adicionales': this.Creados, "Codigo": this.inventarioDocumento.CodigoBarras});
        },
        Agregar: function(){
           
            if(this.tomosAdicionales>0)
            {
                let Volumenes= [];
                let MovimientosDocumentos= []
                for (var i = 0; i < this.tomosAdicionales; i++)
                {
                    
                        Volumenes.push({
                            "VolumenId": 0,
                            "Fojas": 0,
                            "Contenedor": 0,
                            "Area": {"AreaId": this.areaTomos.Area.AreaId},
                            "InventarioDocumentoId": this.inventarioDocumento.InventarioDocumentoId,
                            "EstatusVolumenes":{ "TipoEstatusVolumenId": 3},
                            "UsuarioQueRegistra": {"IdUsuario": 0},
                            "FechaRegistro": moment().format()
                        }),
                        MovimientosDocumentos.push({
                        "AreaQuePresta": {"AreaId": this.areaTomos.Area.AreaId },
                        "AreaQueRecibe": {"AreaId": this.areaTomos.Area.AreaId },
                        "IncidenteId": null,
                        "Observaciones": "Movimiento generado por adiccion de tomo en Juzgado",
                        "TiposMovimientos": {"TipoMovimientoId": 3},
                        "UsuarioQuienPresta": {"IdUsuario": null},
                        "UsuarioQuienRecibe": {"IdUsuario": null},
                        "UsuarioQuienRegistra": {"IdUsuario": null },
                        "VolumenId": null,})
                    
                    
                }
                var peticion = {Volumenes, MovimientosDocumentos}
                axios.post(api.conexion + api.ArchivoJudicial.AgregaTomos, peticion,
                    comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                    .then( respuesta => {
                    if(respuesta.data.SiHayError)
                    {
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    }
                    else
                        {   
                            //comun.mensajeDeAlerta(respuesta.data.Satisfactorio);
                            this.Creados = true;
                            this.ModalClose();
                        }
                    comun.SeEstaCargandoInformacion(false);
                    })
                    .catch(excepcion => {
                        console.log(excepcion);
                        console.log("fallo por parametros");
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);
                    });
                //comun.mensajeDeAlerta("Se agregaron "+ this.tomosAdicionales + " al Documento", null, null)
            }
            else
            {
                comun.mensajeDeAlerta("No hay tomos adicciones para agregar al Documento", null, null)
            }
        }
    },
    mounted(){
        this.Mostrar()
    },
    computed: {
        total(){
            var suma = (isNaN(parseInt(this.tomosAdicionales)) ==false ? parseInt(this.tomosAdicionales) : 0 ) + parseInt(this.tomosActuales)
            return suma;
        }
    }
}
</script>
<style scoped>
    .modal-content {
      background-color:  #7e7f74;
    }
    .modal-header {
        background-color:  #007573;
    }
</style>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/addTomos1aVez.vue